export function getSubdomain(): string {
  if (process.env.NEXT_PUBLIC_IS_ALPHA_WEBSITE === 'true') return 'alpha'
  if (process.env.NEXT_PUBLIC_IS_CRAWL_WEBSITE === 'true') return 'roar'
  if (process.env.NEXT_PUBLIC_IS_BETA_WEBSITE === 'true') return 'beta'
  if (process.env.NEXT_PUBLIC_IS_PRODUCTION_WEBSITE === 'true' || typeof window === 'undefined') return 'www'
  return window.location.hostname
}
